export const uniqueSymbol: unique symbol = Symbol('UNSAFE_INTERNAL_styles');
